import { render } from "./P3.vue?vue&type=template&id=e390f522&scoped=true"
import script from "./P3.vue?vue&type=script&lang=js"
export * from "./P3.vue?vue&type=script&lang=js"

import "./P3.vue?vue&type=style&index=0&id=e390f522&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e390f522"

export default script